import { Injectable, Inject } from '@angular/core';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Observer, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommonEnum } from '../../../services/api-names';
import {
  TechLibPortalConfig,
  TECH_LIB_PORTAL_CONFIG,
} from '../../../tech-lib-portal.interceptor';
import { SessionService } from '../../../services/session.service';
import { Router } from '@angular/router';
import { Utils } from '../../../utils/utils';
import { ClientData } from '../../completedata/request/models/client-data.model';

//import { GetUserBusinessAreaResponseModel } from '../models/getUserBussinessArea-response.model';
//import { GetUserBusinessAreaResponseInterface } from '../interfaces/getUserBussinessArea-response.interface';
/*
import { Serializer } from '../../../helpers/serializer/seriealizer';
*/

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpBackend: HttpBackend,
    private session: SessionService,
    private router: Router,
    private http: HttpClient, //private serializer: Serializer
  ) {}

  private updateSession() {
    this.config.accessToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
  }

  apiCustodianClient(): Observable<ClientData> {
    if (this.session.sessionToken != '') this.updateSession();

    var url = this.config.baseApi + CommonEnum.api_custodian_client;
    return this.http.get<any>(url).pipe(
      map(
        (res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        },
        catchError((err) => {
          return throwError(err);
        }),
      ),
    );
  }
  getClientData(): Observable<ClientData> {
    if (this.session.sessionToken != '') this.updateSession();

    var url = this.config.baseApi + CommonEnum.apirest_get_client_data;
    return this.http.get<any>(url).pipe(
      map(
        (res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          localStorage.setItem('ClientCode', this.session.clientCode);
          return res;
        },
        catchError((err) => {
          return throwError(err);
        }),
      ),
    );
  }

  automaticLogging(code: string, token: string): Observable<any> {
    var url = Utils.formatString(
      this.config.baseApi + CommonEnum.automatic_login,
      [code, token],
    );
    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  getBussinesAreaData(domain: string): Observable<any> {
    this.updateSession();
    var url = Utils.formatString(
      this.config.baseApi + CommonEnum.bussinesarea_data,
      [domain],
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      }),
    );
  }

  logOut(): Observable<any> {
    this.updateSession();
    let url = this.config.baseApi + CommonEnum.logout_client;
    let body = { observe: 'body' };
    return this.http.post<any>(url, body, {
      observe: 'response',
    });
  }
}
